import { render, staticRenderFns } from "./settlement-success.vue?vue&type=template&id=31bce272&scoped=true&"
import script from "./settlement-success.vue?vue&type=script&lang=ts&"
export * from "./settlement-success.vue?vue&type=script&lang=ts&"
import style0 from "./settlement-success.vue?vue&type=style&index=0&id=31bce272&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bce272",
  null
  
)

export default component.exports